import {VersionType} from "./access-matrix.service";
import {ConfigureListOfGroups, ConfigureVersionType, LocalSettingsState} from "./local-settings.state";
import {Injectable} from "@angular/core";
import {Store} from "@ngxs/store";
import {Group} from "@icure/api";
import {AccessRight} from "../models/oAuth.model";

@Injectable({
  providedIn: 'root',
})
export class LocalSettingsService {
  initialized: Promise<void>;
  private _basicAuth: string = '';
  private _connectionType: 'Basic' | 'OAuth' = 'OAuth';
  // @ts-ignore
  private _accessRight: AccessRight = null;
  private _oauthIdToken: string | null = null;
  constructor(
    private store: Store,
    private localSettingsState: LocalSettingsState
  ) {
    this.initialized = this.localSettingsState.initialized;
  }

  public setVersion(version: VersionType){
    this.store.dispatch(new ConfigureVersionType(version))
  }

  public get version(): VersionType{
      return this.store.selectSnapshot(LocalSettingsState.versionType)
  }

  public setListOfGroupIds(groups: Array<Group>){
    this.store.dispatch(new ConfigureListOfGroups(groups));
  }

  public get listOfGroups(): Array<Group>{
    return this.store.selectSnapshot(LocalSettingsState.listOfGroups);
  }

  public setBasicAuth(basicAuth: string){
    this._basicAuth = basicAuth;
  }

  public get basicAuth(): string{
    return this._basicAuth;
  }

  public setAccessRight(accessRight: AccessRight) {
    this._accessRight = accessRight;
  }

  public get getAccessRight() {
    return this._accessRight;
  }

  public setConnectionType(connectionType: 'Basic' | 'OAuth') {
    this._connectionType = connectionType;
  }

  public get getConnectionType(): 'Basic' | 'OAuth' {
    return this._connectionType;
  }

  public get oauthIdToken(): string | null {
    if(this._connectionType === 'OAuth') {
      return this._oauthIdToken;
    }
    return null;
  }

  public set oauthIdToken(idToken: string) {
    if(this._connectionType === 'OAuth') {
      this._oauthIdToken = idToken;
    }
  }
}
